import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { fetchWidgetChannels } from 'flow/actions/channels-actions';
import { fetchQueues } from 'flow/actions/pbx-actions';
import { fetchProfiles } from 'flow/actions/profile-actions';
import useAppContext from 'flow/hooks/useAppContext';
import { selectExtensionActiveProfile } from 'flow/selectors/ExtensionSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';

import { getActiveUntil } from 'flow/utils';
import { getStandardProfileDescriptionInUserLanguage } from 'flow/utils/profile-utils';

interface Props {
    extensionKey: ExtensionKey;
}

const CurrentProfile = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchProfiles(extensionKey));
    }, [dispatch, extensionKey]);

    useEffect(() => {
        dispatch(fetchQueues());
        dispatch(fetchWidgetChannels('apps'));
    }, [dispatch]);

    const activeProfile = useAppSelector((state) =>
        selectExtensionActiveProfile(state, extensionKey),
    );

    if (!activeProfile) {
        return null;
    }

    return (
        <div className="flex gap-1 text-gray-500">
            <p className="truncate">
                {getStandardProfileDescriptionInUserLanguage(
                    activeProfile.get('description'),
                    i18next,
                )}
            </p>
            <p>{getActiveUntil(activeProfile, i18next)}</p>
        </div>
    );
};

export default CurrentProfile;
